export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const STORE_SELF = 'STORE_SELF'

export const STORE_PROJECTS = 'STORE_PROJECTS'
export const STORE_CATEGORY_PROJECTS = 'STORE_CATEGORY_PROJECTS'

export const STORE_CATEGORIES = 'STORE_CATEGORIES'

export const STORE_USER = 'STORE_USER'

export const STORE_TAGS = 'STORE_TAGS'

export const STORE_STATSCTICS_EMPLOYEE_OVERVIEW = 'STORE_STATSCTICS_EMPLOYEE_OVERVIEW'

export const STORE_PROJECT = 'STORE_PROJECT'

export const STORE_STATS_PROJECT = 'STORE_STATS_PROJECT'

export const STORE_SECTIONS = 'STORE_SECTIONS'

export const STORE_WORKDAYS = 'STORE_WORKDAYS'

export const STORE_WORKDAY_BY_ID = 'STORE_WORKDAY_BY_ID'

export const STORE_DATA_SEARCH = 'STORE_DATA_SEARCH'

export const STORE_ALL_TAGS = 'STORE_ALL_TAGS'

export const STORE_WORK_DAY = 'STORE_WORK_DAY'

export const STORE_TASKS = 'STORE_TASKS'

export const ROLES_IN_PROJECT = 'ROLES_IN_PROJECT'

export const STORE_PROJECTS_BY_USER_ID = 'STORE_PROJECTS_BY_USER_ID'

export const STORE_ALL_EMPLOYEES = 'STORE_ALL_EMPLOYEES'

export const STORE_USER_WITHOUT_PAGINATION = 'STORE_USER_WITHOUT_PAGINATION'

export const STORE_KEYWORDS = 'STORE_KEYWORDS'

export const STORE_PLAN = 'STORE_PLAN'

export const STORE_MY_PLAN_ACTIVE = 'STORE_MY_PLAN_ACTIVE'

export const STORE_CURRENT_USER_PROJECTS = 'STORE_CURRENT_USER_PROJECTS'

export const STORE_PLANNED_TASKS = 'STORE_PLANNED_TASKS'

export const STORE_PLANNED_TASKS_BY_PROJECTS = 'STORE_PLANNED_TASKS_BY_PROJECTS'

export const STORE_SELF_WORKDAY = 'STORE_SELF_WORKDAY'

export const STORE_MY_INFO = 'STORE_MY_INFO'

export const STORE_PROJECT_BRIEF = 'STORE_PROJECT_BRIEF'

export const STORE_LEAVES_STATICS = 'STORE_LEAVES_STATICS'

export const STORE_LEAVES_REMAINING = 'STORE_LEAVES_REMAINING'

export const STORE_VERSIONS = 'STORE_VERSIONS'

export const STORE_LEAVE_TYPE_FOR_EMPLOYEE = 'STORE_LEAVE_TYPE_FOR_EMPLOYEE'

export const STORE_UNLINKED_EMPLOYEE = 'STORE_UNLINKED_EMPLOYEE'
